<template>
  <div>    
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/automationer">Visa alla automationer</router-link>
        <router-link tag="li" to="/automationer/ny">Skapa ny automation</router-link>
      </ul>
      <div class="clear"></div>
    </div>
    
    <div v-if="!editing">
      <h3>Information</h3>
      <p>Automationer skapar du i antingen iOS-appen eller Android-appen.</p>
    </div>
    <div v-else>
      <div style="padding:8px;background:#e74c3c;margin-bottom:14px;border-radius:4px;color:#FFF;">
        <strong>Observera!</strong> Du redigerar en gammal automation, automationer skall skapas i våra appar, läs mer om detta <a href="https://support.nexa.se/hc/sv/articles/360006101038-Gamla-och-nya-automationer" style="color:#fff;text-decoration:underline;">här</a>.
      </div>

      <div class="item">
        <input type="text" v-model="name" placeholder="Namn på automationen">
      </div>
      
      <h4>När...</h4>
      <p class="descr">Här väljer du vad som skall köra igång automationen, varje gång händelsen nedan inträffar kommer automationen att köras igång för att validera eventuella villkor som finns.</p>
      
      <div class="item">
        <select v-model="nodeId" @change="changedNode">
          <option value="" disabled selected>Välj en enhet...</option>
          <option v-for="node in $root.data.nodes" :value="node.id">{{ node.name || 'Enheten har inget namn' }}</option>
        </select>      
      </div>
      
      <div class="item">
        <select v-if="nodeId" v-model="capability">
          <option value="null" disabled selected>Välj en typ...</option>
          <option v-for="cap in getNodeForId(nodeId).capabilities" v-if="cap in $root.capabilities" :value="cap">{{ $root.capabilities[cap].name }}</option>
        </select>
      </div>
      
      <div class="item" v-if="capability">
        <select v-if="getCapabilityOptions(capability).type === 'boolean'" v-model="value">
          <option v-for="(value, key) in getCapabilityOptions(capability).values" :value="key">{{ key }}</option>
        </select>
        
        <div v-if="getCapabilityOptions(capability).type === 'number'">
          <div class="item">
            <select v-model="operator">
              <option v-for="operator in availableOperators" :value="operator.id">{{ operator.label }}</option>
            </select>
          </div>

          <input type="number" v-model.number="value">
        </div>
      </div>
      
      <div>
        <button @click="record"><span v-if="!recording">Börja spela in</span><span v-else>Spelar in, tryck för att avsluta</span></button>
      </div>
      
      <hr>
      
      
      <h4>Kör...</h4>
      <p class="descr">Detta är vad som skall hända när både händelsen samt dina villkor har validerats. Exempelvis tända enheter, skicka notiser eller liknande. Du kan specificera hur många kommandon som helst.</p>
      
      <div class="item">
        <commands-view :commands="commands"></commands-view>
      </div>
          
      <div class="item">
        <button @click="doSave" :disabled="saving || !ok" class="green"><span v-if="!saving">Spara automationen</span><span v-else>Sparar...</span></button>
      </div>
    
      <div class="item" v-if="editing">
        <button class="red" @click="remove" :disabled="saving"><span v-if="!saving">Radera automationen</span><span v-else>Raderar...</span></button>
      </div>
    </div>
  </div>
</template>

<script>
  import { eventbus } from '../eventbus.js'
  import { HTTP } from '../http.js'
  import commandsView from './views/commandsView'

  export default {
    name: 'automationer',
    components: {
      commandsView
    },
    data () {
      return {
        id: 0,
        capability: null,
        nodeId: '',
        value: false,
        operator: '$eq',
        availableOperators: [
          { id: '$eq', label: 'är exakt' },
          { id: '$gt', label: 'är över' },
          { id: '$gte', label: 'är exakt eller över' },
          { id: '$lt', label: 'är under' },
          { id: '$lte', label: 'är exakt eller under' },
          { id: '$ne', label: 'är inte' }
        ],
        commands: [],
        recording: false,
        setCapabilities: [],
        conditions: [],
        name: '',
        saving: false,
        editing: false
      }
    },
    created () {
      for (const cap in this.$root.capabilities) {
        const capability = this.$root.capabilities[cap]
        capability.set && this.setCapabilities.push(cap)
      }
      
      this.editing = ('id' in this.$route.params)
      
      // Betyder att vi editerar en automation så vi måste hämta den
      if (this.editing) {
        this.id = this.$route.params.id

        const json = this.$root.data.triggers.find(trigger => trigger.id === this.id)
        
        this.name = json.name
        this.commands = json.scenario.commands
        
        const trigger = json.expression['$and']
        const nodeId = trigger[0]['$eq'][1]
        const node = this.$root.data.nodes.find(node => node.id === nodeId)
        this.nodeId = node.id || 0
        
        this.capability = trigger[1]['$eq'][1].replace(/\"/g, '').trim()
                 
        const operator = Object.keys(trigger[2])[0]
        const value = Object.values(trigger[2])[0]
          
        this.operator = operator

        if (!Array.isArray(value)) {
          this.value = value
          if (operator === '$is') {
            this.operator = '$eq'
            this.value = true
          } else if(operator == '$not') {
            this.operator = '$ne'
            this.value = false
          }
        } else {
            this.value = value[1]
        }
        
        
        // Parsa ut villkoren på något sätt här, jag vet inte alls hur man skall sköta
        // detta på det snyggaste sättet men det får bli som det blir just nu känner jag.
        let conditions = trigger.slice(3, trigger.length)
        conditions = conditions[0]
        const conditionMainOperator = Object.keys(conditions)[0]
        
        conditions[conditionMainOperator].forEach(conditionOrConditionGroup => {
          const operator = Object.keys(conditionOrConditionGroup)[0]
          
          let type = ''     
          // $or och $and betyder att det är en villkorsgrupp,
          // annars är det ett rent villkor.
          if (['$or', '$and'].includes(operator)) {
            type = 'group'
          }

          this.conditions.push({
            type: type,
            operator: operator,
            condition: conditionOrConditionGroup[operator]
          })
        })
      }
    },
    methods: {
      record () {
        this.recording = !this.recording

        if (!this.recording) {
          eventbus.$off('nodeEvent')

          eventbus.$once('nodeEvent', (json) => {
            this.showSaveRecordButton = true
            this.capability = json.name
            this.nodeId = json.sourceNode
            this.value = json.value
            this.recording = false         
          })
        }
      },
      
      remove () {
        this.saving = true 
        
        if (confirm('Är du säker på att du vill radera automationen?')) {
          // Radera från vår lista och därför vy
          const index = this.$root.data.triggers.findIndex(trigger => trigger.id === this.id)
          this.$root.data.triggers.splice(index, 1)
                    
          HTTP.delete('triggers/' + this.id)
          .then(res => res.data)
          .then(json => {

          })
                 
          this.$router.push({
            name: 'automationer'
          })

        }
      },
      
    
      addCommand () {
        if (this.commandType === 'node') {
          this.commands.push({
            type: 'RunNodeMethodCmd',
            delay: 0,
            cmd: {
              cap: '',
              arguments: [],
              targetNode: 0,
              method: 'setValue'
            }
          })
        } else if (this.commandType === 'push') {
          this.commands.push({
            type: 'SendPushCmd',
            message: '',
            sound: 'default',
            deviceIds: [],
            badge: 1,
            delay: 0
          })
        }

        // Återställ så man kan välja igen
        this.commandType = ''
      },
      findNodesForCapability (capability) {
        return this.$root.data.nodes.filter(node => node.capabilities.includes(capability))
      },
      
      getNodeForId (nodeId) {
        return this.$root.data.nodes.find(node => node.id === nodeId)
      },
      
      getCapabilityOptions (capability) {
        return this.$root.capabilities[capability]
      },
      
      changedNode () {
        this.capability = ''
        this.value = ''
      },
      
      doSave () {
        const payload = this.payload
        this.saving = true
        
        let path = 'triggers'
        if ('id' in this.$route.params) {
          path = 'triggers/' + this.$route.params.id
        }
        
        HTTP.post(path, payload)
        .then(res => res.data)
        .then(json => {
          console.log(json)

          if (this.editing) {
            const index = this.$root.data.triggers.findIndex(trigger => trigger.id === this.id)
            this.$root.data.triggers.splice(index, 1)
          }
                    
          let obj = payload
          obj.id = json.id

          this.$root.data.triggers.push(obj)

          this.$router.push({
            name: 'automationer'
          })
        })
      }
    },
    computed: {
      ok () {
        return this.name.length && this.commands.length && this.nodeId && this.capability && this.operator
      },
      
      // Hämtar ut noder som har capabilities
      getNodesWithSetCapability () {
        return this.$root.data.nodes.filter(node => {
          return node.capabilities.some(v => this.setCapabilities.includes(v))
        })
      },
      
      payload () {
        let value = this.value
        if (value === 'false') {
          value = false
        } else if (value === 'true') {
          value = true
        }
        
        const obj = {
          name: this.name,
          triggerType: 'MongoTrigger',
          enabled: true,
          timeoutSec: 0,
          expression: {
            '$and': [
              {
                '$eq': [
                  'event.sourceNode',
                  this.nodeId
                ]
              },
              {
                '$eq': [
                  'event.name',
                  '"' + this.capability + '"'
                ]
              },
              {
                [this.operator]: [
                  'event.value',
                  value
                ]
              }
            ]
          },
          scenario: {
            commands: this.commands
          }
        }
        
        return obj
      }
    },
    destroyed () {}
  }
</script>

<style scoped>
  .item {
    padding-bottom:10px;
  }
  
  h4 {
    margin-bottom:0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/automationer_ny.vue